<template>
  <div class="catalog-box">
    <div class="header-box">
      <div class="symbol" />
      <div class="name">数据分类</div>
    </div>
    <div
      v-for="(item, index) in catalogList"
      :key="index"
      :class="`item-box ${isActive(item) ? 'active' : ''}`"
      @click="handleCatalogClick(item)">
      {{ item.name }}
    </div>
  </div>
</template>

<script>
import { getDataDictionaryTypeService } from '@/service/dataDictionary'
export default {
  data() {
    return {
      catalogList: []
    }
  },
  props: {
    currCatalog: Object
  },
  mounted() {
    this.initCatalogList()
  },
  methods: {
    async initCatalogList() {
      let catalogList = await this.queryDataDictionaryType()
      if (catalogList.length) {
        this.catalogList = catalogList
        let currCatalog = catalogList[0]
        this.$emit('handleCatalogClick', currCatalog)
      }
    },
    handleCatalogClick(currCatalog) {
      this.$emit('handleCatalogClick', currCatalog)
    },
    isActive(catalogInfo) {
      return catalogInfo.id === this.currCatalog.id
    },
    async queryDataDictionaryType() {
      let projId = this.$route.params.projId
      let response = await getDataDictionaryTypeService({ projId })
      if (response.isSuccess) {
        let data = response.data
        return data
      } else {
        this.$message.error(response.errMsg)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.catalog-box {
  flex-shrink: 0;
  width: 240px;
  height: 100%;
  padding: 16px;
  border-radius: 16px;
  font-size: 14px;
  color: var(--tree-node-text-color);
  background: var(--project-source-tree-bgColor);
  border: 1px solid var(--project-source-tree-border-color);
  text-align: left;
  box-shadow: var(--base-bg-light-color83);

  .header-box {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 12px;

    .symbol {
      width: 4px;
      height: 16px;
      background: var(--base-primary-color);
    }

    .name {
      text-align: left;
      font-size: 16px;
      color: var(--project-header-title-color);
      font-weight: 500;
    }
  }

  .item-box {
    padding: 4px 8px;
    border-radius: 4px 4px 4px 4px;
    cursor: pointer;
    margin-top: 4px;
    line-height: 22px;

    &:first-child {
      margin-top: 0;
    }

    &:hover {
      color: var(--base-primary-bgColor);
      background: var(--base-bg-light-color77);
    }

    &.active {
      color: var(--base-primary-bgColor);
      background: var(--base-bg-light-color77);
    }
  }
}
</style>
